export const messages = {
  en: {
    assetInventory: {
      title: 'Asset Inventory',
      name: 'Inventory Name',
      namePlaceholder: 'Required, please enter inventory name',
      staffName: 'Inventory Staff',
      staffNamePlaceholder: 'Required, please enter inventory staff name',
      storehouse: 'Storehouse',
      storehousePlaceholder: 'Please select storehouse',
      invTime: 'Inventory Time',
      invTimePlaceholder: 'Required, please select inventory time',
      remark: 'Remark',
      remarkPlaceholder: 'Required, please enter remark',
      itemInfo: 'Item Information',
      selectItem: 'Select Items',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      isFixed: 'Is Fixed',
      referencePrice: 'Reference Price',
      selectPrice: 'Please select price',
      stock: 'Stock',
      afterQuantity: 'After Quantity',
      afterQuantityPlaceholder: 'Required, please enter quantity after inventory',
      operation: 'Operation',
      remove: 'Remove',
      cancel: 'Cancel',
      submit: 'Submit',
      validateError: 'Please complete all required fields',
      selectItemError: 'Please select at least one item',
      selectPriceError: 'Please select price for all items',
      quantityError: 'Please enter valid quantity for all items',
      nameRequired: 'Inventory name is required',
      staffNameRequired: 'Inventory staff is required',
      storehouseRequired: 'Storehouse is required',
      invTimeRequired: 'Inventory time is required',
      remarkRequired: 'Remark is required',
      selectStorehouseFirst: 'Please select storehouse first',
      saveError: 'Failed to save inventory'
    },
   
  },
  zh: {
    assetInventory: {
      title: '资产盘点',
      name: '盘点名称',
      namePlaceholder: '必填，请填写盘点名称',
      staffName: '盘点人',
      staffNamePlaceholder: '必填，请填写盘点人',
      storehouse: '选择仓库',
      storehousePlaceholder: '请选择仓库',
      invTime: '盘点日期',
      invTimePlaceholder: '必填，请填写盘点日期',
      remark: '盘点说明',
      remarkPlaceholder: '必填，请填写盘点说明',
      itemInfo: '物品信息',
      selectItem: '选择物品',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      isFixed: '是否是固定物品',
      referencePrice: '参考价格',
      selectPrice: '请选择价格',
      stock: '物品库存',
      afterQuantity: '盘点后数量',
      afterQuantityPlaceholder: '必填，请填盘点后数量',
      operation: '操作',
      remove: '移除',
      cancel: '取消',
      submit: '提交',
      validateError: '请完成所有必填项',
      selectItemError: '请至少选择一件物品',
      selectPriceError: '请为所有物品选择价格',
      quantityError: '请为所有物品输入有效数量',
      nameRequired: '盘点名称不能为空',
      staffNameRequired: '盘点人不能为空',
      storehouseRequired: '请选择仓库',
      invTimeRequired: '盘点日期不能为空',
      remarkRequired: '盘点说明不能为空',
      selectStorehouseFirst: '请先选择仓库',
saveError: '保存盘点失败'
    },
  },
  'zh-TW': {
    assetInventory: {
      title: '資產盤點',
      name: '盤點名稱',
      namePlaceholder: '必填，請填寫盤點名稱',
      staffName: '盤點人',
      staffNamePlaceholder: '必填，請填寫盤點人',
      storehouse: '選擇倉庫',
      storehousePlaceholder: '請選擇倉庫',
      invTime: '盤點日期',
      invTimePlaceholder: '必填，請填寫盤點日期',
      remark: '盤點說明',
      remarkPlaceholder: '必填，請填寫盤點說明',
      itemInfo: '物品信息',
      selectItem: '選擇物品',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemSpec: '物品規格',
      itemCode: '物品編碼',
      isFixed: '是否是固定物品',
      referencePrice: '參考價格',
      selectPrice: '請選擇價格',
      stock: '物品庫存',
      afterQuantity: '盤點後數量',
      afterQuantityPlaceholder: '必填，請填盤點後數量',
      operation: '操作',
      remove: '移除',
      cancel: '取消',
      submit: '提交',
      validateError: '請完成所有必填項',
      selectItemError: '請至少選擇一件物品',
      selectPriceError: '請為所有物品選擇價格',
      quantityError: '請為所有物品輸入有效數量',
      nameRequired: '盤點名稱不能為空',
      staffNameRequired: '盤點人不能為空',
      storehouseRequired: '請選擇倉庫',
      invTimeRequired: '盤點日期不能為空',
      remarkRequired: '盤點說明不能為空',
      selectStorehouseFirst: '請先選擇倉庫',
      saveError: '保存盤點失敗'
    },
  }
}